import { render, staticRenderFns } from "./dlrz.vue?vue&type=template&id=92c235a8&scoped=true&"
import script from "./dlrz.vue?vue&type=script&lang=js&"
export * from "./dlrz.vue?vue&type=script&lang=js&"
import style0 from "./dlrz.vue?vue&type=style&index=0&id=92c235a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c235a8",
  null
  
)

export default component.exports